import { render, staticRenderFns } from "./FileImageInput.vue?vue&type=template&id=23fc72b0&scoped=true&"
import script from "./FileImageInput.vue?vue&type=script&lang=js&"
export * from "./FileImageInput.vue?vue&type=script&lang=js&"
import style0 from "./FileImageInput.vue?vue&type=style&index=0&id=23fc72b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fc72b0",
  null
  
)

export default component.exports